import { Card, SquareDotLoadingIndicator, Text } from '@joor/design-system'
import { generatePath } from 'react-router-dom'
import styled from 'styled-components'

import { fromGlobalId } from 'utils/transformations/graphql'

import { SWATCH_MANAGEMENT } from 'routes/paths'

import StyleColor from './StyleColor'
import { StyleColorsIds } from 'features/Linesheets/Modals/ManageImagesModal/manageImagesModal.ids'
import messages from 'features/Linesheets/Modals/ManageImagesModal/manageImagesModal.messages'
import useStore from 'features/Linesheets/Modals/ManageImagesModal/store/useManageImagesStore'

const StyledCard = styled(Card)`
  header {
    max-width: 100%;
    background-color: var(--color-neutral-000-full);
  }

  &:not(.loading) > section {
    padding: 0 11px 11px 16px;
    margin: 0 5px 5px 0;
    > div {
      border-top: 1px solid var(--color-primary-200);
    }
  }

  &.loading {
    position: relative;
    width: auto;
    height: auto;

    & > section {
      min-height: 128px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
`

const StyleColorsContainer = styled.div`
  max-height: 252px;
  overflow-y: auto;
`

const StyleColors = (): JSX.Element => {
  const isStyleDataLoading = useStore((state) => state.isStyleDataLoading)
  const linesheetId = useStore((state) => state.linesheetId)
  const styleColors = useStore((state) => state.styleColors)
  const amountOfColorsWithImages = styleColors?.reduce(
    (acc, color) => acc + (color?.imageUrl ? 1 : 0),
    0,
  )

  return (
    <StyledCard
      testId={StyleColorsIds.Card}
      className={isStyleDataLoading ? 'loading' : ''}
      title={`${messages.colorImages}${
        styleColors
          ? ` (${amountOfColorsWithImages} of ${styleColors?.length})`
          : ''
      }`}
      actionButtonId={StyleColorsIds.EditSwatches}
      actionButtonTestId={StyleColorsIds.EditSwatches}
      actionButtonLabel={messages.editSwatches}
      onClickActionButton={() =>
        window.open(
          generatePath(SWATCH_MANAGEMENT, {
            linesheetId: fromGlobalId(linesheetId)?.id || '',
          }),
        )
      }
    >
      <Text letterSpacing="normal" margin="9px 0 20px">
        {messages.chooseSingleImage}
      </Text>
      {!isStyleDataLoading ? (
        <StyleColorsContainer>
          {styleColors?.map((color) => (
            <StyleColor key={color.id} color={color} />
          ))}
        </StyleColorsContainer>
      ) : (
        <SquareDotLoadingIndicator />
      )}
    </StyledCard>
  )
}

export default StyleColors
